import { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { CONST } from '../../../../../const/const'
import useGetEventData from '../../../../../hooks/users/common/useGetEventData'
import ManageEventRevenueHeader from '../ManageEventRevenueHeader'
import ManageEventRevenueTabs from '../ManageEventRevenueTabs'
import ManageEventRevenueWrapper from '../ManageEventRevenueWrapper'
import SpectatorRevenueDisplayTabs from './tabs/SpectatorRevenueDisplayTabs'

const SpectatorRevenue = () => {
  const { getAllData } = useGetEventData()
  const { eventId } = useParams<{ eventId: string }>()

  const [searchValue, setSearchValue] = useState('')
  const [eventTab, setEventTab] = useState(CONST.UI.EVENTS.REVENUE.TABS.ALL.VALUE)

  useEffect(() => {
    if (eventId) {
      getAllData(eventId, [
        'v01_event_fees',
        'v01_event_details',
        'v01_event_registered_users',
        'v01_event_ticketing',
      ])
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [eventId])

  return (
    <ManageEventRevenueWrapper eventId={eventId}>
      <>
        <div className="w-full flex mb-4 flex-wrap">
          <ManageEventRevenueHeader revenueType={'Spectator Ticket'} />

          <ManageEventRevenueTabs
            eventTab={eventTab}
            setEventTab={setEventTab}
            setSearchValue={setSearchValue}
          />
          <SpectatorRevenueDisplayTabs
            eventId={eventId}
            eventTab={eventTab}
            searchValue={searchValue}
          />
        </div>
      </>
    </ManageEventRevenueWrapper>
  )
}

export default SpectatorRevenue
